(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[26],{

/***/ 1301:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7729);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2903);




function PageMeta(props) {
  var _props$description;

  var title = props.title;
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsxs */ .BX)((next_head__WEBPACK_IMPORTED_MODULE_0___default()), {
    children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("title", {
      children: title
    }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("meta", {
      content: title,
      property: "og:title"
    }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("meta", {
      content: "ChatSift",
      property: "og:site_name"
    }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("meta", {
      content: "/assets/chatsift.png",
      property: "og:image"
    }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("meta", {
      content: (_props$description = props.description) !== null && _props$description !== void 0 ? _props$description : 'A powerful solution for your day-to-day moderation bot needs.',
      property: "description"
    }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("meta", {
      name: "theme-color",
      content: "#318EEE"
    })]
  });
}

/* harmony default export */ __webpack_exports__["Z"] = (PageMeta);

/***/ }),

/***/ 5774:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5235);
/* harmony import */ var react_error_boundary__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(589);
/* harmony import */ var react_error_boundary__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(react_error_boundary__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _useUser__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5696);
/* harmony import */ var _hooks_useCheckedRouter__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3353);
/* harmony import */ var _utils_fetch__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(914);
/* harmony import */ var _utils_urls__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(1256);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }







function useLoggedInUser() {
  var user = (0,_useUser__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)();
  var loggedInUser = user.data,
      error = user.error,
      isLoading = user.isLoading;
  var router = (0,_hooks_useCheckedRouter__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)();
  var handleError = (0,react_error_boundary__WEBPACK_IMPORTED_MODULE_5__.useErrorHandler)();

  if (error !== null && !(error instanceof _utils_fetch__WEBPACK_IMPORTED_MODULE_3__/* .APIError */ .Hx && error.payload.statusCode === 401)) {
    handleError(error);
    return user;
  }

  if (!isLoading && loggedInUser === undefined) {
    void router.push(_utils_urls__WEBPACK_IMPORTED_MODULE_4__/* .logIn */ .Ib);
    return _objectSpread(_objectSpread({}, user), {}, {
      isLoading: true
    });
  }

  return user;
}

/* harmony default export */ __webpack_exports__["Z"] = (useLoggedInUser);

/***/ }),

/***/ 3268:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);


function useRand(min, max) {
  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(0),
      rand = _useState[0],
      setRand = _useState[1];

  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    setRand(Math.floor(Math.random() * (max - min + 1)) + min);
  }, [min, max]);
  return rand;
}

/* harmony default export */ __webpack_exports__["Z"] = (useRand);

/***/ }),

/***/ 660:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ dashboard; }
});

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js + 3 modules
var toConsumableArray = __webpack_require__(2746);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(406);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(8526);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ./src/components/Button/index.tsx + 1 modules
var Button = __webpack_require__(6556);
// EXTERNAL MODULE: ./src/components/ButtonLink/index.tsx
var ButtonLink = __webpack_require__(4748);
// EXTERNAL MODULE: ./src/components/Text/index.tsx + 1 modules
var Text = __webpack_require__(2762);
// EXTERNAL MODULE: ./src/stitches/stitches.config.ts + 1 modules
var stitches_config = __webpack_require__(8325);
;// CONCATENATED MODULE: ./src/components/DashBotUpsell/style.ts


var Upsell = (0,stitches_config/* styled */.zo)('div', {
  backgroundColor: stitches_config/* theme.colors.bgCard */.rS.colors.bgCard,
  borderThin: stitches_config/* theme.colors.onBgTertiary */.rS.colors.onBgTertiary,
  borderRadius: stitches_config/* theme.radii.lg */.rS.radii.lg,
  padding: stitches_config/* theme.space.lg */.rS.space.lg,
  display: 'flex',
  gap: stitches_config/* theme.space.lg */.rS.space.lg,
  justifyContent: 'space-between',
  variants: {
    direction: {
      column: {
        flexDirection: 'column'
      },
      row: {
        flexDirection: 'row'
      }
    }
  }
});
var Main = (0,stitches_config/* styled */.zo)('div', {
  displayFlex: 'column',
  gap: stitches_config/* theme.space.md */.rS.space.md
});
var Buttons = (0,stitches_config/* styled */.zo)('div', {
  display: 'flex',
  gap: stitches_config/* theme.space.md */.rS.space.md,
  variants: {
    direction: {
      column: {
        flexDirection: 'column',
        alignItems: 'flex-start'
      },
      row: {
        flexDirection: 'row',
        alignItems: 'center'
      }
    }
  }
});
var Title = (0,stitches_config/* styled */.zo)(Text/* Text */.x, {
  displayFlex: 'row',
  gap: stitches_config/* theme.space.xs */.rS.space.xs
});
// EXTERNAL MODULE: ./src/data/bots/index.ts + 3 modules
var bots = __webpack_require__(3402);
// EXTERNAL MODULE: ./src/utils/urls.ts
var urls = __webpack_require__(1256);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(2903);
;// CONCATENATED MODULE: ./src/components/DashBotUpsell/index.tsx









function DashBotUpsell(_ref) {
  var botId = _ref.botId;
  var Icon = bots/* botIcons */.j[botId];
  var bot = bots/* default */.Z[botId];
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Upsell, {
    direction: {
      '@initial': 'column',
      '@dashboardMaxWidth': 'row'
    },
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Main, {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Title, {
        kind: "heading4",
        color: "primary",
        weight: "bold",
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Icon, {
          width: 24,
          height: 24
        }), bot.name]
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
        children: bot.description.card
      })]
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Buttons, {
      direction: {
        '@initial': 'column',
        '@small': 'row'
      },
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* Button */.z, {
        as: ButtonLink/* ButtonLink */.Z,
        buttonType: "ghost",
        href: urls/* botPage */.i6(botId),
        ghostHasBorder: true,
        external: true,
        children: "Learn more"
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* Button */.z, {
        as: ButtonLink/* ButtonLink */.Z,
        buttonType: "callToAction",
        href: urls/* botInvite */.g1(botId),
        external: true,
        children: "Add to server"
      })]
    })]
  });
}

/* harmony default export */ var components_DashBotUpsell = (DashBotUpsell);
// EXTERNAL MODULE: ./src/components/Footer/index.tsx + 5 modules
var Footer = __webpack_require__(1127);
// EXTERNAL MODULE: ../../node_modules/next/link.js
var next_link = __webpack_require__(9097);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ../../node_modules/react-loading-skeleton/dist/index.mjs
var dist = __webpack_require__(4080);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(5235);
// EXTERNAL MODULE: ./src/utils/constants.ts
var constants = __webpack_require__(9526);
;// CONCATENATED MODULE: ./src/components/GuildCard/style.ts


var _hover, _styled;




var guildCardInnerGap = stitches_config/* theme.space.md */.rS.space.md;
var guildCardSmallDashWidth = '80vw';
var GuildTitle = (0,stitches_config/* styled */.zo)(Text/* Text */.x, {
  whiteSpace: 'nowrap',
  width: '100%',
  textOverflow: 'ellipsis',
  overflow: 'hidden'
});
var CardHeader = (0,stitches_config/* styled */.zo)('div', {
  displayFlex: 'row',
  alignItems: 'center',
  gap: stitches_config/* theme.space.md */.rS.space.md
});
var NotInvitedHover = (0,stitches_config/* styled */.zo)('div', {
  displayFlex: 'column',
  gap: guildCardInnerGap
});
var BotListNotInvited = (0,stitches_config/* styled */.zo)('ul', {
  displayFlex: 'row',
  gap: stitches_config/* theme.space.md */.rS.space.md
});
var Bot = (0,stitches_config/* styled */.zo)('a', {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: stitches_config/* theme.colors.onBgTertiary */.rS.colors.onBgTertiary,
  borderRadius: stitches_config/* theme.radii.sm */.rS.radii.sm,
  width: stitches_config/* theme.sizes.image */.rS.sizes.image,
  height: stitches_config/* theme.sizes.image */.rS.sizes.image
});
var GuildImage = (0,stitches_config/* styled */.zo)('img', {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: stitches_config/* theme.colors.onBgTertiary */.rS.colors.onBgTertiary,
  width: "".concat(stitches_config/* theme.sizes.image */.rS.sizes.image, " !important"),
  height: stitches_config/* theme.sizes.image */.rS.sizes.image,
  borderRadius: "".concat(stitches_config/* theme.radii.rounded */.rS.radii.rounded, " !important"),
  borderThin: stitches_config/* theme.colors.onBgSecondary */.rS.colors.onBgSecondary
});
var GuildAcronym = (0,stitches_config/* styled */.zo)(GuildImage, {
  '&::after': {
    maxWidth: '70%',
    content: 'attr(data-full)',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
  }
});
var GuildCardBase = (0,stitches_config/* styled */.zo)('a', (_styled = {
  displayFlex: 'column',
  gap: guildCardInnerGap,
  padding: constants/* guildCardGap */.qc,
  borderRadius: stitches_config/* theme.radii.lg */.rS.radii.lg,
  borderThin: stitches_config/* theme.colors.onBgSecondary */.rS.colors.onBgSecondary,
  minWidth: constants/* guildCardWidthMobile */.QW,
  height: 144
}, (0,defineProperty/* default */.Z)(_styled, "&:not(:hover) ".concat(NotInvitedHover), {
  display: 'none'
}), (0,defineProperty/* default */.Z)(_styled, "variants", {
  mobile: {
    "true": {
      width: guildCardSmallDashWidth
    },
    "false": {
      width: constants/* guildCardWidthDesktop */.VL
    }
  },
  isInvited: {
    "true": {
      backgroundColor: stitches_config/* theme.colors.bgCard */.rS.colors.bgCard,
      '#header-title': {
        display: 'none'
      }
    }
  },
  isSkeleton: {
    "true": (0,defineProperty/* default */.Z)({}, "".concat(NotInvitedHover), {
      display: 'none'
    })
  }
}), (0,defineProperty/* default */.Z)(_styled, "compoundVariants", [{
  isInvited: false,
  isSkeleton: false,
  css: {
    '&:not(:hover) #header-title': {
      display: 'none'
    },
    '&:hover': (_hover = {
      '#not-invited-hover-title': {
        display: 'none'
      }
    }, (0,defineProperty/* default */.Z)(_hover, "".concat(GuildAcronym, ", ").concat(GuildImage), {
      width: stitches_config/* theme.sizes.smallImage */.rS.sizes.smallImage,
      height: stitches_config/* theme.sizes.smallImage */.rS.sizes.smallImage,
      aspectRatio: '1'
    }), (0,defineProperty/* default */.Z)(_hover, "".concat(GuildAcronym, "::after"), {
      content: 'attr(data-first-letter)'
    }), (0,defineProperty/* default */.Z)(_hover, '.not-invited', {
      display: 'none'
    }), _hover)
  }
}, {
  isInvited: true,
  isSkeleton: false,
  css: {
    cursor: 'pointer'
  }
}]), _styled));
var NameAndBots = (0,stitches_config/* styled */.zo)('div', {
  displayFlex: 'column',
  gap: stitches_config/* theme.space.xxs */.rS.space.xxs
});
var BotList = (0,stitches_config/* styled */.zo)('ul', {
  displayFlex: 'row',
  gap: stitches_config/* theme.space.xxs */.rS.space.xxs
});
// EXTERNAL MODULE: ./src/hooks/useRand.ts
var useRand = __webpack_require__(3268);
// EXTERNAL MODULE: ./src/svg/SvgAma.tsx
var SvgAma = __webpack_require__(1933);
// EXTERNAL MODULE: ./src/svg/SvgAutoModerator.tsx
var SvgAutoModerator = __webpack_require__(8311);
// EXTERNAL MODULE: ./src/svg/SvgModmail.tsx
var SvgModmail = __webpack_require__(191);
// EXTERNAL MODULE: ./src/utils/getGuildAcronym.ts
var getGuildAcronym = __webpack_require__(9258);
;// CONCATENATED MODULE: ./src/components/GuildCard/index.tsx











 // ??? it is used????
// eslint-disable-next-line react/no-unused-prop-types





function GuildCard(_ref) {
  var guild = _ref.guild;
  var randomBotListCount = (0,useRand/* default */.Z)(1, 3);
  var icon = guild !== null && guild !== void 0 && guild.icon ? "https://cdn.discordapp.com/icons/".concat(guild.id, "/").concat(guild.icon, ".png") : null;
  var href = urls/* dashboard.index */.sI.index(String(guild === null || guild === void 0 ? void 0 : guild.id));
  var isInvited = guild !== undefined && (guild.hasAutomoderator || guild.hasModmail || guild.hasAma);
  var showInvitedBotsSkeleton = !guild && randomBotListCount > 1.5;
  var skeletonWidth = (0,useRand/* default */.Z)(40, 100);
  var Container = isInvited ? function (_ref2) {
    var children = _ref2.children;
    return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
      href: href,
      children: children
    });
  } : react.Fragment;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Container, {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GuildCardBase, {
      as: isInvited ? 'a' : 'div',
      isInvited: isInvited || showInvitedBotsSkeleton,
      isSkeleton: !guild,
      href: href,
      mobile: {
        '@initial': true,
        '@smallestDashboardWidth': false
      },
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [guild === undefined ? (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GuildImage, {
          as: dist/* default */.Z
        }) : (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CardHeader, {
          "data-is-invited": isInvited,
          children: [icon ? (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GuildImage, {
            src: icon
          }) : (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GuildAcronym, {
            as: Text/* Text */.x,
            kind: "caption",
            "data-first-letter": guild.name[0],
            "data-full": (0,getGuildAcronym/* default */.Z)(guild.name)
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GuildTitle, {
            id: "header-title",
            color: "primary",
            weight: "bold",
            children: guild.name
          })]
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(NameAndBots, {
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GuildTitle, {
            id: "not-invited-hover-title",
            color: "primary",
            weight: "bold",
            children: guild === undefined ? (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(dist/* default */.Z, {
              width: "".concat(skeletonWidth, "%")
            }) : guild.name
          }), isInvited || showInvitedBotsSkeleton ? (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BotList, {
            children: guild === undefined ? (0,toConsumableArray/* default */.Z)(Array.from({
              length: Math.ceil(randomBotListCount)
            })).map(function (_, index) {
              return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(dist/* default */.Z, {
                width: 24,
                height: 24
              }, index);
            }) : (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
              children: [guild.hasAutomoderator && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("li", {
                children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SvgAutoModerator/* default */.Z, {})
              }), guild.hasAma && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("li", {
                children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SvgAma/* default */.Z, {})
              }), guild.hasModmail && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("li", {
                children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SvgModmail/* default */.Z, {})
              })]
            })
          }) : (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
            children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
              kind: "caption",
              className: "not-invited",
              children: guild === undefined ? (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(dist/* default */.Z, {
                width: "50%"
              }) : 'Not invited'
            }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(NotInvitedHover, {
              children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                kind: "caption",
                children: "Invite a bot:"
              }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(BotListNotInvited, {
                children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("li", {
                  children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Bot, {
                    href: urls/* botInvite */.g1('automoderator'),
                    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SvgAutoModerator/* default */.Z, {
                      width: 32,
                      height: 32
                    })
                  })
                }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("li", {
                  children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Bot, {
                    href: urls/* botInvite */.g1('ama'),
                    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SvgAma/* default */.Z, {
                      width: 32,
                      height: 32
                    })
                  })
                }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("li", {
                  children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Bot, {
                    href: urls/* botInvite */.g1('modmail'),
                    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SvgModmail/* default */.Z, {
                      width: 32,
                      height: 32
                    })
                  })
                })]
              })]
            })]
          })]
        })]
      })
    })
  });
}

/* harmony default export */ var components_GuildCard = (GuildCard);
// EXTERNAL MODULE: ./src/components/Heading/index.tsx + 1 modules
var Heading = __webpack_require__(3621);
// EXTERNAL MODULE: ./src/components/PageMeta/index.tsx
var PageMeta = __webpack_require__(1301);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js + 3 modules
var slicedToArray = __webpack_require__(8529);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(2269);
// EXTERNAL MODULE: ../../node_modules/@react-aria/searchfield/dist/module.js + 4 modules
var dist_module = __webpack_require__(3979);
;// CONCATENATED MODULE: ./src/svg/SvgSearch.tsx


function SvgSearch(_ref) {
  var _ref$themeColor = _ref.themeColor,
      themeColor = _ref$themeColor === void 0 ? 'currentColor' : _ref$themeColor,
      className = _ref.className;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("svg", {
    className: className,
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
      d: "M9.5 3C11.2239 3 12.8772 3.68482 14.0962 4.90381C15.3152 6.12279 16 7.77609 16 9.5C16 11.11 15.41 12.59 14.44 13.73L14.71 14H15.5L20.5 19L19 20.5L14 15.5V14.71L13.73 14.44C12.59 15.41 11.11 16 9.5 16C7.77609 16 6.12279 15.3152 4.90381 14.0962C3.68482 12.8772 3 11.2239 3 9.5C3 7.77609 3.68482 6.12279 4.90381 4.90381C6.12279 3.68482 7.77609 3 9.5 3M9.5 5C7 5 5 7 5 9.5C5 12 7 14 9.5 14C12 14 14 12 14 9.5C14 7 12 5 9.5 5Z",
      fill: themeColor
    })
  });
}

/* harmony default export */ var svg_SvgSearch = (SvgSearch);
;// CONCATENATED MODULE: ./src/components/SearchBar/style.ts



var Icon = (0,stitches_config/* styled */.zo)(svg_SvgSearch, {
  position: 'absolute',
  top: '50%',
  translate: '0 -50%',
  right: stitches_config/* theme.space.lg */.rS.space.lg,
  color: stitches_config/* theme.colors.textSecondary */.rS.colors.textSecondary
});
var SearchField = (0,stitches_config/* styled */.zo)('input', {
  width: '100%',
  fontWeight: stitches_config/* theme.fontWeights.thin */.rS.fontWeights.thin,
  fontSize: stitches_config/* theme.fontSizes.two */.rS.fontSizes.two,
  flex: '1 1 auto',
  color: stitches_config/* theme.colors.textPrimary */.rS.colors.textPrimary,
  backgroundColor: stitches_config/* theme.colors.onBgTertiary */.rS.colors.onBgTertiary,
  borderThin: stitches_config/* theme.colors.onBgSecondary */.rS.colors.onBgSecondary,
  borderRadius: stitches_config/* theme.radii.lg */.rS.radii.lg,
  padding: "".concat(stitches_config/* theme.space.md */.rS.space.md, " ").concat(stitches_config/* theme.space.huge */.rS.space.huge, " ").concat(stitches_config/* theme.space.md */.rS.space.md, " ").concat(stitches_config/* theme.space.lg */.rS.space.lg),
  '&::placeholder': {
    color: stitches_config/* theme.colors.textSecondary */.rS.colors.textSecondary
  },
  '&:focus': (0,defineProperty/* default */.Z)({
    outline: 'none',
    borderWidth: stitches_config/* theme.borderWidths.thin */.rS.borderWidths.thin,
    borderStyle: stitches_config/* theme.borderStyles.normal */.rS.borderStyles.normal,
    borderColor: stitches_config/* theme.colors.textPrimary */.rS.colors.textPrimary,
    '&::placeholder': {
      color: stitches_config/* theme.colors.textPrimary */.rS.colors.textPrimary
    }
  }, "".concat(Icon), {
    color: stitches_config/* theme.colors.textPrimary */.rS.colors.textPrimary
  }),
  '&[disabled]': {
    opacity: 0.5,
    cursor: 'not-allowed'
  }
});
var SearchContainer = (0,stitches_config/* styled */.zo)('div', (0,defineProperty/* default */.Z)({
  position: 'relative'
}, "".concat(SearchField, ":focus + ").concat(Icon), {
  color: stitches_config/* theme.colors.textPrimary */.rS.colors.textPrimary
}));
;// CONCATENATED MODULE: ./src/components/SearchBar/index.tsx



var _excluded = ["className", "state"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }







function SearchBar(_ref) {
  var className = _ref.className,
      state = _ref.state,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  var ref = (0,react.useRef)(null);

  var _state = (0,slicedToArray/* default */.Z)(state, 2),
      value = _state[0],
      setValue = _state[1];

  var _useSearchField = (0,dist_module/* useSearchField */.t)(props, {
    value: value,
    setValue: setValue
  }, ref),
      inputProps = _useSearchField.inputProps;

  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(SearchContainer, {
    className: className,
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SearchField, _objectSpread(_objectSpread({}, inputProps), {}, {
      ref: ref
    })), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Icon, {})]
  });
}

/* harmony default export */ var components_SearchBar = (SearchBar);
// EXTERNAL MODULE: ./src/hooks/useLoggedInUser.ts
var useLoggedInUser = __webpack_require__(5774);
// EXTERNAL MODULE: ./src/svg/SvgRefresh.tsx
var SvgRefresh = __webpack_require__(1382);
;// CONCATENATED MODULE: ./src/pages/dashboard/index.tsx





















var MainHeadingContainer = (0,stitches_config/* styled */.zo)('div', {
  display: 'flex',
  justifyContent: 'space-between',
  gap: stitches_config/* theme.space.lg */.rS.space.lg,
  variants: {
    direction: {
      column: {
        flexDirection: 'column',
        alignItems: 'flex-start'
      },
      row: {
        flexDirection: 'row',
        alignItems: 'center'
      }
    }
  }
});
var SectionContainer = (0,stitches_config/* styled */.zo)('div', {
  displayFlex: 'column',
  '& > *:first-of-type': {
    marginBottom: stitches_config/* theme.space.xl */.rS.space.xl
  },
  '&:not(:first-of-type)': {
    marginTop: stitches_config/* theme.space.xxl */.rS.space.xxl
  }
});
var Container = (0,stitches_config/* styled */.zo)('main', {
  displayFlex: 'column',
  flex: '1 0 auto',
  alignItems: 'stretch',
  justifyContent: 'space-between',
  width: 'fit-content',
  height: '100%',
  margin: '0 auto',
  padding: constants/* dashboardPadding */.SP,
  variants: {
    mobile: {
      "true": {
        maxWidth: constants/* smallestDashboardWidth */.EH - constants/* dashboardPadding */.SP * 2
      },
      "false": {
        maxWidth: constants/* dashboardMaxWidth */.AA
      }
    }
  }
});
var SearchBarModified = (0,stitches_config/* styled */.zo)(components_SearchBar, {
  marginBottom: stitches_config/* theme.space.lg */.rS.space.lg
});
var Guilds = (0,stitches_config/* styled */.zo)('ul', {
  display: 'grid',
  gridTemplateColumns: "repeat(".concat(constants/* guildCardsPerPage */.OZ, ", 1fr)"),
  gap: stitches_config/* theme.space.lg */.rS.space.lg,
  maxWidth: constants/* dashboardMaxWidth */.AA - constants/* dashboardPadding */.SP * 2,
  variants: {
    columns: {
      nGuilds: {
        gridTemplateColumns: "repeat(".concat(constants/* guildCardsPerPage */.OZ, ", 1fr)")
      },
      2: {
        gridTemplateColumns: "1fr 1fr"
      },
      1: {
        gridTemplateColumns: "1fr"
      }
    }
  }
});
var NoServersFoundContainer = (0,stitches_config/* styled */.zo)('div', {
  displayFlex: 'column',
  gap: stitches_config/* theme.space.xl */.rS.space.xl,
  variants: {
    mobile: {
      "true": {
        maxWidth: constants/* smallestDashboardWidth */.EH - constants/* dashboardPadding */.SP * 4,
        width: guildCardSmallDashWidth
      },
      "false": {
        maxWidth: 'unset',
        width: "min(".concat(constants/* dashboardMaxWidth */.AA - constants/* dashboardPadding */.SP * 2, "px, 80vw)")
      }
    }
  }
});
var NoScript = (0,stitches_config/* styled */.zo)('noscript', {
  displayFlex: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  flex: '1 0 auto'
});
var NoServersHeader = (0,stitches_config/* styled */.zo)('div', {
  displayFlex: 'column',
  gap: stitches_config/* theme.space.xxs */.rS.space.xxs
});
var BotUpsells = (0,stitches_config/* styled */.zo)('ul', {
  display: 'flex',
  flexDirection: 'column',
  gap: stitches_config/* theme.space.xl */.rS.space.xl
});
var numberOfSkeletonGuilds = 16;

function saveDataCache(data, expiresAt) {
  localStorage.setItem('dashboardData', JSON.stringify({
    data: data,
    expiresAt: expiresAt
  }));
}

function getDataCache() {
  var cache = localStorage.getItem('dashboardData');

  if (!cache) {
    return null;
  }

  var _JSON$parse = JSON.parse(cache),
      data = _JSON$parse.data,
      expiresAt = _JSON$parse.expiresAt;

  if (expiresAt && new Date(expiresAt) < new Date()) {
    return null;
  }

  return data;
}

function Dashboard() {
  var _ref2, _dataToUse$guilds, _guilds$length, _dataToUse$guilds$len, _dataToUse$guilds2;

  var _useLoggedInUser = (0,useLoggedInUser/* default */.Z)(),
      data = _useLoggedInUser.data,
      refetch = _useLoggedInUser.refetch,
      isRefetching = _useLoggedInUser.isRefetching,
      isFetching = _useLoggedInUser.isFetching;

  var _useState = (0,react.useState)(''),
      search = _useState[0],
      setSearch = _useState[1];

  var _useState2 = (0,react.useState)(),
      dataCache = _useState2[0],
      setDataCache = _useState2[1];

  var _useState3 = (0,react.useState)(false),
      isPerformingUserInitiatedRefetch = _useState3[0],
      setIsPerformingUserInitiatedRefetch = _useState3[1];

  var dataToUse = isRefetching ? undefined : data;
  var refetchGuilds = (0,react.useCallback)( /*#__PURE__*/(0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
    return regenerator_default().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            setIsPerformingUserInitiatedRefetch(true);
            _context.next = 3;
            return refetch();

          case 3:
            setIsPerformingUserInitiatedRefetch(false);

          case 4:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  })), [refetch]);
  (0,react.useEffect)(function () {
    setDataCache(getDataCache());
  }, []);
  (0,react.useEffect)(function () {
    if ((dataToUse === null || dataToUse === void 0 ? void 0 : dataToUse.guilds) !== undefined) {
      saveDataCache(dataToUse.guilds, new Date(Date.now() + 1000 * 60 * 60 * 5
      /* 1h */
      ));
    }
  }, [dataToUse]);
  var filtered = (_ref2 = (_dataToUse$guilds = dataToUse === null || dataToUse === void 0 ? void 0 : dataToUse.guilds) !== null && _dataToUse$guilds !== void 0 ? _dataToUse$guilds : dataCache) === null || _ref2 === void 0 ? void 0 : _ref2.filter(function (guild) {
    return guild.name.toLowerCase().includes(search.toLowerCase());
  });
  var guilds = filtered === null || filtered === void 0 ? void 0 : filtered.sort(function (g1, g2) {
    return Number(g1.hasAma) + Number(g1.hasModmail) + Number(g1.hasAutomoderator) < Number(g2.hasAma) + Number(g2.hasModmail) + Number(g2.hasAutomoderator) ? 1 : -1;
  });
  var isNotReady = guilds === undefined || isPerformingUserInitiatedRefetch;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PageMeta/* default */.Z, {
      title: "Dashboard"
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(NoScript, {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("style", {
        children: "\n\t\t\t\t\t\t#container {\n\t\t\t\t\t\t\tdisplay: none;\n\t\t\t\t\t\t}\n\t\t\t\t\t"
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
        kind: "body",
        color: "primary",
        weight: "bold",
        children: "JavaScript is required for this page to work"
      })]
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Container, {
      id: "container",
      mobile: {
        '@initial': true,
        '@dashboardMaxWidth': false
      },
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(SectionContainer, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(MainHeadingContainer, {
          direction: {
            '@initial': 'column',
            '@small': 'row'
          },
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Heading/* default */.Z, {
            title: "Configure bots",
            subtitle: "Select or add a community to manage."
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Button/* Button */.z, {
            buttonType: "ghost",
            onPress: function onPress() {
              return void refetchGuilds();
            },
            isDisabled: isFetching,
            "data-loading": isFetching,
            ghostHasBorder: true,
            children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SvgRefresh/* default */.Z, {
              themeColor: stitches_config/* theme.colors.textSecondary.toString */.rS.colors.textSecondary.toString()
            }), "Refresh"]
          })]
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SearchBarModified, {
          state: [search, setSearch],
          placeholder: "Search for a server",
          "aria-label": "Search for a server",
          isDisabled: isNotReady
        }), isNotReady || ((_guilds$length = guilds === null || guilds === void 0 ? void 0 : guilds.length) !== null && _guilds$length !== void 0 ? _guilds$length : 0) > 0 ? (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Guilds, {
          columns: {
            '@initial': 1,
            '@smallestDashboardWidth': 2,
            '@dashboardMaxWidth': 'nGuilds'
          },
          children: isNotReady ? (0,toConsumableArray/* default */.Z)(Array.from({
            length: numberOfSkeletonGuilds
          })).map(function (_, index) {
            return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("li", {
              children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components_GuildCard, {
                guild: undefined
              })
            }, index);
          }) : guilds === null || guilds === void 0 ? void 0 : guilds.map(function (guild) {
            return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("li", {
              children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components_GuildCard, {
                guild: guild
              }, guild.id)
            }, guild.id);
          })
        }) : (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(NoServersFoundContainer, {
          mobile: {
            '@initial': true,
            '@dashboardMaxWidth': false
          },
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(NoServersHeader, {
            children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
              kind: "heading3",
              color: "primary",
              weight: "bold",
              children: ((_dataToUse$guilds$len = dataToUse === null || dataToUse === void 0 ? void 0 : (_dataToUse$guilds2 = dataToUse.guilds) === null || _dataToUse$guilds2 === void 0 ? void 0 : _dataToUse$guilds2.length) !== null && _dataToUse$guilds$len !== void 0 ? _dataToUse$guilds$len : 0) > 0 ? 'No results' : 'No servers found'
            }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
              children: "Invite a bot by clicking on the respective buttons"
            })]
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BotUpsells, {
            children: Object.keys(bots/* default */.Z).map(function (botId) {
              return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components_DashBotUpsell, {
                botId: botId
              }, botId);
            })
          })]
        })]
      })
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Footer/* default */.Z, {})]
  });
}

/* harmony default export */ var dashboard = (Dashboard);

/***/ }),

/***/ 1382:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2903);


function SvgRefresh(_ref) {
  var _ref$themeColor = _ref.themeColor,
      themeColor = _ref$themeColor === void 0 ? 'currentColor' : _ref$themeColor;
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("svg", {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("path", {
        d: "M12 6V9L16 5L12 1V4C9.87827 4 7.84344 4.84285 6.34315 6.34315C4.84285 7.84344 4 9.87827 4 12C4 13.57 4.46 15.03 5.24 16.26L6.7 14.8C6.25 13.97 6 13 6 12C6 10.4087 6.63214 8.88258 7.75736 7.75736C8.88258 6.63214 10.4087 6 12 6ZM18.76 7.74L17.3 9.2C17.74 10.04 18 11 18 12C18 13.5913 17.3679 15.1174 16.2426 16.2426C15.1174 17.3679 13.5913 18 12 18V15L8 19L12 23V20C14.1217 20 16.1566 19.1571 17.6569 17.6569C19.1571 16.1566 20 14.1217 20 12C20 10.43 19.54 8.97 18.76 7.74Z",
        fill: themeColor
      })
    })
  });
}

/* harmony default export */ __webpack_exports__["Z"] = (SvgRefresh);

/***/ }),

/***/ 9258:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8529);


function getGuildAcronym(guildName) {
  return guildName.split(' ').map(function (_ref) {
    var _ref2 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_ref, 1),
        firstLetter = _ref2[0];

    return firstLetter;
  }).join('');
}

/* harmony default export */ __webpack_exports__["Z"] = (getGuildAcronym);

/***/ }),

/***/ 5792:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/dashboard",
      function () {
        return __webpack_require__(660);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [97,77,385,774,888,179], function() { return __webpack_exec__(5792); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);